import React, {Component} from 'react';
import { Container, Row, Col } from 'reactstrap';
import { sendData } from '../../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class Hilfe extends Component {

	componentDidMount() {
        sendData('', '', '', 'viewed', { page: 'hilfe' });
		window.scrollTo(0, 0);
	}

	render() {

		return (
			<section className="terms privacy-policy">
			<Container fluid>
				<Row>
					<Col xs="12">
						<div className="terms-title-wrap">
							<h2 className="terms-section-title">
                                Hilfe
                            </h2>
						</div>
					</Col>
				</Row>
				<Row className="no-gutters">
					<Col xs="12" className="terms-list">
                        <p className="terms-para">
                            Sollten Sie noch Fragen haben, dann können Sie Kontakt mit uns unter <a href="mailto: gamelords.ch@silverlines.info">gamelords.ch@silverlines.info</a> Aufnehmen. Bitte vergessen Sie nicht, Ihre Handynummer anzugeben. Wir setzen uns so schnell wie möglich mit Ihnen in Verbindung! Telefonnummer Helpdesk: 044 5816 275       
                        </p>
                    </Col>
				</Row>
			</Container>
		</section>
		);
	}
}

export default Hilfe;



// WEBPACK FOOTER //
// ./src/components/StaticPages/Hilfe.js